import { isEmpty } from 'lodash';
import { useGetDefaultAssemblies } from 'src/hooks/api';
import { IDefaultAssembly } from 'src/interfaces';

import { mapMultipleAssemblyState } from './AssemblyState.helper';

export const useGetAssemblyState = (assemblyIDs: (string | number)[]) => {
  const result = useGetDefaultAssemblies(
    [`assembly_id.list=${assemblyIDs.join('|')}`],
    !isEmpty(assemblyIDs),
    'timing',
  );

  const state = mapMultipleAssemblyState(
    assemblyIDs,
    (result?.data ?? []) as IDefaultAssembly[],
  );

  return {
    ...result,
    data: state,
  };
};
